import { Flex, Image } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import SectionHeader from './SectionHeader';
import { awards } from '../data/aboutData';

// Create motion components
const MotionFlex = motion(Flex);

/**
 * "Recognition": a white band of award logos, all at the same height
 */
export default function Recognition() {
	return (
		<Flex
			width={"100%"}
			flexDirection={"column"}
			alignItems={"center"}
			gap={8}
			paddingY={{ base: 10, md: 16 }}
		>
			<SectionHeader size={"sm"} title={"Recognition"} />

			{/* Logo Strip (white, since most of the logos are made for light backgrounds) */}
			<MotionFlex
				as={"ul"}
				listStyleType={"none"}
				width={{ base: "90%", lg: "80%" }}
				maxWidth={"1000px"}
				flexWrap={"wrap"}
				justifyContent={"center"}
				alignItems={"center"}
				columnGap={{ base: 8, md: 12 }}
				rowGap={6}
				paddingX={{ base: 6, md: 10 }}
				paddingY={{ base: 6, md: 8 }}
				backgroundColor={"white.100"}
				borderRadius={"xl"}
				boxShadow={"lg"}
				initial={{ opacity: 0, y: 30 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: true, amount: 0.3 }}
				transition={{ duration: 0.6, ease: "easeOut" }}
			>
				{awards.map((award) => (
					<Flex as={"li"} key={award.title} alignItems={"center"}>
						<Image
							src={award.image}
							alt={`${award.title}, ${award.organization}`}
							title={`${award.title}, ${award.organization}`}
							height={{ base: "72px", md: "88px", lg: "100px" }}
							width={"auto"}
							maxWidth={"100%"}
							objectFit={"contain"}
							// White-only logos would vanish on the white strip
							filter={award.invertImage ? "invert(1)" : undefined}
						/>
					</Flex>
				))}
			</MotionFlex>
		</Flex>
	);
}
